import type { Match } from "@/types";

export const matches: Match[] = [
  {
    id: "m1",
    homeTeamId: "t-lal",
    awayTeamId: "t-bos",
    startTime: "2026-10-12T20:00:00",
    status: "live",
    homeScore: 88,
    awayScore: 84,
    period: "第四节 06:24",
    stage: "常规赛",
    venue: "加密科普竞技场",
    summary:
      "两队展开强强对话，湖人凭借内线优势在第三节建立领先，凯尔特人依靠连续三分紧咬比分，末节争夺进入白热化。",
    viewers: "128.6万",
  },
  {
    id: "m2",
    homeTeamId: "t-gsw",
    awayTeamId: "t-phx",
    startTime: "2026-10-12T19:30:00",
    status: "live",
    homeScore: 102,
    awayScore: 99,
    period: "第三节 02:10",
    stage: "常规赛",
    venue: "大通中心",
    summary:
      "进攻大战持续升温，勇士依靠快速传切外线开火，太阳由中距离跳投回应，双方比分交替领先。",
    viewers: "96.3万",
  },
  {
    id: "m3",
    homeTeamId: "t-mil",
    awayTeamId: "t-mia",
    startTime: "2026-10-12T21:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "论坛球馆",
    summary:
      "东西部硬仗对决，雄鹿坐镇主场迎战热火，内线对抗与外线防守将成为本场比赛的胜负关键。",
    viewers: "—",
  },
  {
    id: "m4",
    homeTeamId: "t-den",
    awayTeamId: "t-okc",
    startTime: "2026-10-12T21:30:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "球场之巅",
    summary:
      "西部榜首之争，掘金主场高原作战，雷霆以年轻活力发起冲击，核心对位看点十足。",
    viewers: "—",
  },
  {
    id: "m5",
    homeTeamId: "t-nyk",
    awayTeamId: "t-phi",
    startTime: "2026-10-13T20:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "麦迪逊广场花园",
    summary: "东部焦点战，尼克斯主场迎战76人，麦迪逊广场花园的主场氛围将成为重要变量。",
    viewers: "—",
  },
  {
    id: "m6",
    homeTeamId: "t-dal",
    awayTeamId: "t-min",
    startTime: "2026-10-13T21:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "美国航空中心",
    summary: "独行侠主场迎战森林狼，挡拆进攻与内线双塔防守的正面交锋。",
    viewers: "—",
  },
  {
    id: "m7",
    homeTeamId: "t-bos",
    awayTeamId: "t-mia",
    startTime: "2026-10-11T20:00:00",
    status: "replay",
    homeScore: 112,
    awayScore: 105,
    period: "已结束",
    stage: "常规赛",
    venue: "TD花园球馆",
    summary: "凯尔特人依靠下半场一波流拉开分差，最终主场击败热火，全场命中18记三分。",
    viewers: "89.2万",
  },
  {
    id: "m8",
    homeTeamId: "t-lal",
    awayTeamId: "t-gsw",
    startTime: "2026-10-11T21:30:00",
    status: "replay",
    homeScore: 118,
    awayScore: 121,
    period: "已结束",
    stage: "常规赛",
    venue: "加密科普竞技场",
    summary: "经典对决，双方末节鏖战至最后一攻，勇士客场险胜湖人，比赛精彩纷呈。",
    viewers: "156.8万",
  },
  {
    id: "m9",
    homeTeamId: "t-phx",
    awayTeamId: "t-dal",
    startTime: "2026-10-11T19:00:00",
    status: "replay",
    homeScore: 99,
    awayScore: 104,
    period: "已结束",
    stage: "常规赛",
    venue: "足迹中心",
    summary: "独行侠客场挑战太阳，东契奇末节连续得分锁定胜局，太阳外线手感冰凉。",
    viewers: "72.4万",
  },
  {
    id: "m10",
    homeTeamId: "t-okc",
    awayTeamId: "t-den",
    startTime: "2026-10-10T20:30:00",
    status: "replay",
    homeScore: 110,
    awayScore: 108,
    period: "已结束",
    stage: "常规赛",
    venue: "佩克体育馆",
    summary: "雷霆主场惊险战胜掘金，谢伊终场前命中中投绝杀，年轻球队展现韧性。",
    viewers: "81.7万",
  },
  {
    id: "m11",
    homeTeamId: "t-mia",
    awayTeamId: "t-nyk",
    startTime: "2026-10-14T20:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "卡塞亚中心",
    summary: "东部强强对话，热火主场迎战尼克斯，强硬防守将贯穿全场。",
    viewers: "—",
  },
  {
    id: "m12",
    homeTeamId: "t-phi",
    awayTeamId: "t-mil",
    startTime: "2026-10-14T21:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "富国银行中心",
    summary: "76人主场迎战雄鹿，恩比德与字母哥的内线对决成为最大看点。",
    viewers: "—",
  },
  {
    id: "m13",
    homeTeamId: "t-min",
    awayTeamId: "t-lal",
    startTime: "2026-10-15T20:30:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "目标中心",
    summary: "森林狼主场迎战湖人，年轻核心与老牌豪门的正面对话。",
    viewers: "—",
  },
  {
    id: "m14",
    homeTeamId: "t-gsw",
    awayTeamId: "t-bos",
    startTime: "2026-10-15T21:30:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "大通中心",
    summary: "总决赛级别的对决，勇士主场迎战凯尔特人，两大王朝碰撞。",
    viewers: "—",
  },
  {
    id: "m15",
    homeTeamId: "t-dal",
    awayTeamId: "t-phx",
    startTime: "2026-10-16T20:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "美国航空中心",
    summary: "独行侠再战太阳，两队外线火力对拼，得分大战一触即发。",
    viewers: "—",
  },
  {
    id: "m16",
    homeTeamId: "t-den",
    awayTeamId: "t-min",
    startTime: "2026-10-16T21:00:00",
    status: "upcoming",
    homeScore: 0,
    awayScore: 0,
    period: "未开始",
    stage: "常规赛",
    venue: "球场之巅",
    summary: "掘金主场迎战森林狼，西部内线顶级对决，约基奇对位双塔。",
    viewers: "—",
  },
];

export const matchMap: Record<string, Match> = matches.reduce(
  (acc, match) => {
    acc[match.id] = match;
    return acc;
  },
  {} as Record<string, Match>,
);